import { MapCenterData, MarkerData } from "common/pages/console/-components/control/Map";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface mapStore {
    //마커
    markersData: MarkerData[];
    setMarkers: (markers: MarkerData[]) => void;
    mapCenter: MapCenterData;
    setMapCenter: (data: MapCenterData) => void;
    mapZoom: number;
    setMapZoom: (zoom: number) => void;
}

export const useMapStore = create<mapStore>()(
    devtools(set => ({
        markersData: [],
        setMarkers: markers => set({ markersData: markers }),
        mapCenter: { lat: 37.49600576222232, lng: 127.06246613726466 }, //지도 중심 위치 설정 기본값 서울시 강남구
        setMapCenter: (data: MapCenterData) => set({ mapCenter: data }),
        mapZoom: 14, //500m
        setMapZoom: (zoom: number) => set({ mapZoom: zoom }),
    })),
);
